import PropTypes from 'prop-types';
import React from 'react';
import MaskedInput from 'react-text-mask';
import EloInput from './EloInput.react.js';
import InputError from './InputError.react.js';

const UPPERCASE_STYLE = { textTransform: 'uppercase' };

const ALPHANUM = /[A-Za-z0-9]/;
const DIGIT = /\d/;

export const MASK_CNPJ_ALFANUMERICO = [
  ALPHANUM,
  ALPHANUM,
  '.',
  ALPHANUM,
  ALPHANUM,
  ALPHANUM,
  '.',
  ALPHANUM,
  ALPHANUM,
  ALPHANUM,
  '/',
  ALPHANUM,
  ALPHANUM,
  ALPHANUM,
  ALPHANUM,
  '-',
  DIGIT,
  DIGIT
];

const uppercasePipe = conformedValue => conformedValue.toUpperCase();

export default class CnpjCpfInput extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.any,
    style: PropTypes.object,
    maxLength: PropTypes.number,
    mask: PropTypes.array,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    errors: PropTypes.object
  };

  static defaultProps = {
    maxLength: 18
  };

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.maskedInputRef = React.createRef();
  }

  handleChange = event => {
    if (event && event.target && typeof event.target.value === 'string') {
      event.target.value = event.target.value.toUpperCase();
    }
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };

  getInputNode = () =>
    (this.maskedInputRef.current && this.maskedInputRef.current.inputElement) ||
    null;

  getValue = () => {
    if (this.props.mask) {
      const node = this.getInputNode();
      return node ? node.value : undefined;
    }
    const input = this.inputRef.current;
    return input && input.getValue ? input.getValue() : undefined;
  };

  focus = () => {
    if (this.props.mask) {
      const node = this.getInputNode();
      if (node) node.focus();
      return;
    }
    const input = this.inputRef.current;
    if (input && input.focus) input.focus();
  };

  clear = () => {
    if (this.props.mask) {
      const node = this.getInputNode();
      if (node) node.value = '';
      return;
    }
    const input = this.inputRef.current;
    if (input && input.clear) input.clear();
  };

  renderWithMask() {
    const { mask, style, label, name, errors, value, ...rest } = this.props;
    const mergedStyle = { ...UPPERCASE_STYLE, ...(style || {}) };
    const errorProps = InputError.createError(name, errors);
    return (
      <div className={`form-group ${errorProps.hasError || ''}`}>
        {label && <label className="label">{label}</label>}
        <MaskedInput
          ref={this.maskedInputRef}
          mask={mask}
          pipe={uppercasePipe}
          guide={false}
          type="text"
          name={name}
          value={value || ''}
          className={errorProps.className}
          {...rest}
          style={mergedStyle}
          onChange={this.handleChange}
        />
        {errorProps.help}
      </div>
    );
  }

  render() {
    if (this.props.mask) {
      return this.renderWithMask();
    }
    const { style, ...rest } = this.props;
    const mergedStyle = { ...UPPERCASE_STYLE, ...(style || {}) };
    return (
      <EloInput
        ref={this.inputRef}
        type="text"
        {...rest}
        style={mergedStyle}
        onChange={this.handleChange}
      />
    );
  }
}
